function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.414L22.004 5.41 20.59 3.996 12 12.586 8.707 9.293l-1.414 1.414L12 15.414z",
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 4a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-3h-2v3H5V6h10a2 2 0 00-2-2H5z",
  fill: "#4038FF"
});

var SvgEngageBounties = function SvgEngageBounties(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjAwMDEgMTUuNDE0M0wyMi4wMDQxIDUuNDEwMzFMMjAuNTg5OCAzLjk5NjA5TDEyLjAwMDEgMTIuNTg1OUw4LjcwNzE4IDkuMjkyOTdMNy4yOTI5NyAxMC43MDcyTDEyLjAwMDEgMTUuNDE0M1oiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZD0iTTUgNEMzLjg5NTQzIDQgMyA0Ljg5NTQzIDMgNlYxOEMzIDE5LjEwNDYgMy44OTU0MyAyMCA1IDIwSDE3QzE4LjEwNDYgMjAgMTkgMTkuMTA0NiAxOSAxOFYxNUgxN1YxOEg1VjZMMTUgNkMxNSA0Ljg5NTQzIDE0LjEwNDYgNCAxMyA0SDVaIiBmaWxsPSIjNDAzOEZGIi8+Cjwvc3ZnPgo=";
export { SvgEngageBounties as ReactComponent };